const makeLimitedList = <TListItem>(list: Array<TListItem>, limit: number) => {
  if (!list)
    return {
      list,
      remainder: false,
    };

  const remainder = list.length - limit;

  return {
    list: list.slice(0, limit),
    remainder: remainder > 0 && remainder,
  };
};

export default makeLimitedList;
